import script from "./ContactMe.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactMe.vue?vue&type=script&setup=true&lang=js"

import "./ContactMe.vue?vue&type=style&index=0&id=6447ec0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6447ec0e"]])

export default __exports__